export default __webpack_public_path__ + "img/sec-5-bg.png";